const VerifoneTransactionResultMessages = {
    0: 'Completed',
    2: 'Referred',
    5: 'Declined',
    6: 'Authorised',
    7: 'Declined/Rejected/Reversed',
    8: 'Communications Failure',
};

module.exports = VerifoneTransactionResultMessages;
